import { TagEditor } from '@/components/TagTextEditor';
import { Box, Typography } from '@mui/material';
import {
  EditButton,
  SimpleShowLayout,
  useRecordContext,
} from 'react-admin';

export const AIPromptsCommandPanel = () => {
  const record = useRecordContext();

  return (
    <SimpleShowLayout record={record}>
      <EditButton />
      <Box component="div">
        <Typography fontWeight="bold">System Message</Typography>
        <TagEditor value={record.systemMessage || ''} disabled />
      </Box>

      <Box component="div">
        <Typography fontWeight="bold">Prompt Prepend</Typography>
        <TagEditor value={record.promptPrepend || ''} disabled />
        {/* <pre
          style={{
            width: "1600px",
            // height: "300px",
            // backgroundColor: "green",
            overflow: "auto",
            whiteSpace: "pre-wrap",
          }}
        >
          {record.promptPrepend}
        </pre> */}
      </Box>

      <Box component="div">
        <Typography fontWeight="bold">Prompt Append</Typography>
        <TagEditor value={record.promptAppend || ''} disabled />
      </Box>
    </SimpleShowLayout>
  );
};
